var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.00004C10.9167 5.00004 11.6667 5.75004 11.6667 6.66671C11.6667 7.58337 10.9167 8.33337 10 8.33337C9.08337 8.33337 8.33337 7.58337 8.33337 6.66671C8.33337 5.75004 9.08337 5.00004 10 5.00004ZM10 13.3334C12.25 13.3334 14.8334 14.4084 15 15H5.00004C5.19171 14.4 7.75837 13.3334 10 13.3334ZM10 3.33337C8.15837 3.33337 6.66671 4.82504 6.66671 6.66671C6.66671 8.50837 8.15837 10 10 10C11.8417 10 13.3334 8.50837 13.3334 6.66671C13.3334 4.82504 11.8417 3.33337 10 3.33337ZM10 11.6667C7.77504 11.6667 3.33337 12.7834 3.33337 15V16.6667H16.6667V15C16.6667 12.7834 12.225 11.6667 10 11.6667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.5695d806.svg";
export { ForwardRef as ReactComponent };